export const changeSubMenuState = (toggle) => ({ type: 'SUB_MENU_STATE', payload: toggle });
export const setSubMenuItems = (items) => ({ type: 'SUB_MENU_ITEMS', payload: items });
export const resetSubMenu = () => ({ type: 'RESET_SUB_MENU', payload: null });
export const setSubMenuPathActive = (bool) => ({ type: 'SUB_MENU_PATH_ACTIVE', payload: bool });
export const setMenuPathActive = (bool) => ({ type: 'NORMAL_MENU_PATH_ACTIVE', payload: bool });
